import {
  AuditOutlined,
  DollarOutlined,
  GlobalOutlined,
  HomeOutlined,
  MergeOutlined,
  NotificationOutlined,
  SettingOutlined,
  TableOutlined,
  TeamOutlined,
  ToolOutlined,
} from '@ant-design/icons';

export interface IRoute {
  path: string;
  title: string;
  description?: string;
  permission?: string;
  icon?: any;
  children?: IRoute[];
  isAdmin?: boolean;
}

export enum Route {
  PAGE500 = 'PAGE500',
  PAGE403 = 'PAGE403',

  LOGIN = 'LOGIN',

  HOME = 'HOME',
  GRANT = 'GRANT',

  TIN_TUC = 'TIN_TUC',

  TUYEN_DUNG = 'TUYEN_DUNG',
  TUYEN_DUNG_UNG_VIEN = 'TUYEN_DUNG_UNG_VIEN',
  TUYEN_DUNG_BAO_CAO = 'TUYEN_DUNG_BAO_CAO',

  NHAN_SU = 'NHAN_SU',
  NHAN_SU_THEM_MOI = 'NHAN_SU_THEM_MOI',

  BANG_CONG = 'BANG_CONG',
  LICH_LAM_VIEC = 'LICH_LAM_VIEC',
  BANG_CONG_THANG = 'BANG_CONG_THANG',
  TONG_HOP_CONG = 'TONG_HOP_CONG',

  DON_XIN_NGHI = 'DON_XIN_NGHI',
  DON_XIN_NGHI_PHE_DUYET = 'DON_XIN_NGHI_PHE_DUYET',
  DON_XIN_NGHI_TONG_HOP = 'DON_XIN_NGHI_TONG_HOP',

  CONG_VIEC = 'CONG_VIEC',

  LUONG = 'LUONG',
  LUONG_TONG_HOP_LUONG = 'LUONG_TONG_HOP_LUONG',
  LUONG_BAC_LUONG = 'LUONG_BAC_LUONG',
  LUONG_KHUNG_NANG_LUC = 'LUONG_KHUNG_NANG_LUC',

  CAU_HINH = 'CAU_HINH',
  CAU_HINH_PHONG_BAN = 'CAU_HINH_PHONG_BAN',
  CAU_HINH_CHUC_VU = 'CAU_HINH_CHUC_VU',
  CAU_HINH_VAI_TRO = 'CAU_HINH_VAI_TRO',
  CAU_HINH_CHE_DO_PHUC_LOI = 'CAU_HINH_CHE_DO_PHUC_LOI',
  CAU_HINH_CONG_CU_LAM_VIEC = 'CAU_HINH_CONG_CU_LAM_VIEC',
  CAU_HINH_CHAM_CONG = 'CAU_HINH_CHAM_CONG',
  CAU_HINH_LOAI_NGHI_PHEP = 'CAU_HINH_LOAI_NGHI_PHEP',

  PHAN_QUYEN = 'PHAN_QUYEN',
  PHAN_QUYEN_NHOM = 'PHAN_QUYEN_NHOM',
  PHAN_QUYEN_NHAN_SU = 'PHAN_QUYEN_NHAN_SU',
}

export const Routes: { [key in Route]: IRoute } = {
  PAGE500: {
    path: '/loi',
    title: 'Lỗi hệ thống',
  },
  PAGE403: {
    path: '/loi-quyen-truy-cap',
    title: 'Lỗi quyền truy cập',
  },

  LOGIN: {
    path: '/dang-nhap',
    title: 'Đăng nhập',
  },

  HOME: {
    path: '/123',
    title: 'Trang chủ',
    icon: <HomeOutlined />,
  },
  GRANT: {
    path: '/grant',
    title: 'Cấp quyền',
    icon: <HomeOutlined />,
  },

  TIN_TUC: {
    path: '/tin-tuc',
    title: 'Tin tức',
    icon: <GlobalOutlined />,
  },

  TUYEN_DUNG: {
    path: '/tuyen-dung',
    title: 'Tuyển dụng',
    icon: <NotificationOutlined />,
  },
  TUYEN_DUNG_UNG_VIEN: {
    path: '/tuyen-dung-ung-vien',
    title: 'Ứng viên',
  },
  TUYEN_DUNG_BAO_CAO: {
    path: '/tuyen-dung-bao-cao',
    title: 'Báo cáo',
  },

  NHAN_SU: {
    path: '/nhan-vien',
    title: 'Nhân viên',
    icon: <TeamOutlined />,
  },
  NHAN_SU_THEM_MOI: {
    path: '/nhan-vien-them-moi',
    title: 'Thêm mới nhân viên',
  },

  BANG_CONG: {
    path: '/bang-cong',
    title: 'Bảng công',
    icon: <TableOutlined />,
  },
  BANG_CONG_THANG: {
    path: '/bang-cong-thang',
    title: 'Bảng công tháng',
  },
  TONG_HOP_CONG: {
    path: '/tong-hop-cong',
    title: 'Tổng hợp công',
  },
  LICH_LAM_VIEC: {
    path: '/lich-lam-viec',
    title: 'Lịch làm việc',
  },

  DON_XIN_NGHI: {
    path: '/don-xin-nghi',
    title: 'Đơn xin nghỉ',
    icon: <AuditOutlined />,
  },
  DON_XIN_NGHI_PHE_DUYET: {
    path: '/don-xin-nghi-phe-duyet',
    title: 'Phê duyệt',
  },
  DON_XIN_NGHI_TONG_HOP: {
    path: '/don-xin-nghi-tong-hop',
    title: 'Tổng hợp phép năm',
  },

  CONG_VIEC: {
    path: '/cong-viec',
    title: 'Công việc',
    icon: <MergeOutlined />,
  },

  LUONG: {
    path: '/luong',
    title: 'Lương',
    icon: <DollarOutlined />,
  },
  LUONG_TONG_HOP_LUONG: {
    path: '/luong-tong-hop-luong',
    title: 'Tổng hợp lương',
  },
  LUONG_BAC_LUONG: {
    path: '/luong-bac-luong',
    title: 'Bậc lương',
  },
  LUONG_KHUNG_NANG_LUC: {
    path: '/luong-khung-nang-luc',
    title: 'Khung năng lực',
  },

  CAU_HINH: {
    path: '/cau-hinh',
    title: 'Cấu hình',
    icon: <SettingOutlined />,
  },
  CAU_HINH_PHONG_BAN: {
    path: '/cau-hinh-phong-ban',
    title: 'Phòng ban',
  },
  CAU_HINH_CHUC_VU: {
    path: '/cau-hinh-chuc-vu',
    title: 'Chức vụ',
  },
  CAU_HINH_VAI_TRO: {
    path: '/cau-hinh-vai-tro',
    title: 'Vai trò',
  },
  CAU_HINH_CHE_DO_PHUC_LOI: {
    path: '/cau-hinh-che-do-phuc-loi',
    title: 'Chế độ phúc lợi',
  },
  CAU_HINH_CONG_CU_LAM_VIEC: {
    path: '/cau-hinh-cong-cu-lam-viec',
    title: 'Công cụ làm việc',
  },
  CAU_HINH_CHAM_CONG: {
    path: '/cau-hinh-cham-cong',
    title: 'Chấm công',
  },
  CAU_HINH_LOAI_NGHI_PHEP: {
    path: '/cau-hinh-loai-nghi-phep',
    title: 'Loại nghỉ phép',
  },

  PHAN_QUYEN: {
    path: '/phan-quyen',
    title: 'Phân quyền',
    icon: <ToolOutlined />,
  },
  PHAN_QUYEN_NHOM: {
    path: '/phan-quyen-nhom',
    title: 'Nhóm người dùng',
  },
  PHAN_QUYEN_NHAN_SU: {
    path: '/phan-quyen-nhan-su',
    title: 'Nhân viên',
  },
};
